import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'

import { AppModule } from './app/app.module'
import { initSentry } from './app/common/sentry-context.service'
import { environment } from './environments/environment'

initSentry()

if (environment.production) {
  enableProdMode()
}

platformBrowserDynamic().bootstrapModule(AppModule).catch(console.error)
